import {
  BulkSubscribePayload,
  BulkSubscribeResponse,
  BulkUnsubscribePayload,
  BulkUnsubscribeResponse,
  Options,
  Resource,
  SubscriptionAction,
  SubscriptionListResponse
} from 'services/api';

import Company from './Company.service';

/**
 * Service for Employee in Comadmin
 */
export default class Subscription extends Company {
  private static instance: Subscription;

  private constructor(options: Options) {
    /* istanbul ignore next */
    super(options);
  }

  /**
   * This return the singleton instance of the class
   * @param {Options} options
   */
  public static getInstance(options: Options) {
    if (!this.instance) {
      this.instance = new this(options);
    }

    return this.instance;
  }

  /**
   * Get a list of subscription plans
   */
  plans() {
    const url = `${this.buildUrl(Resource.Subscription)}/${
      SubscriptionAction.Plans
    }`;
    return this.makeRequest<SubscriptionListResponse>({
      url,
      method: this._request.Get
    });
  }

  bulkSubscribe(payload: BulkSubscribePayload) {
    const url = `${this.buildUrl(Resource.Subscription)}/${
      SubscriptionAction.BulkSubscribe
    }`;
    return this.makeRequest<BulkSubscribeResponse, BulkSubscribePayload>({
      url,
      method: this._request.Post,
      data: payload
    });
  }

  bulkUnsubscribe(payload: BulkUnsubscribePayload) {
    const url = `${this.buildUrl(Resource.Subscription)}/${
      SubscriptionAction.BulkUnsubscribe
    }`;
    return this.makeRequest<BulkUnsubscribeResponse, BulkUnsubscribePayload>({
      url,
      method: this._request.Post,
      data: payload
    });
  }
}
